// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VeeValidate, { Validator } from './vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN';
import extendValidator from "./extendValidate";
import "./extendGlobalComponent"
import  "./vueMethodExtend"
import "./echartExtend"
import './main.ts'
import Treeselect from '@riophae/vue-treeselect';
import { extendValidateMessage } from "./extendValidateMessage";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import CACHE_KEY from "./constant/cacheKey";
import RootType from "./store/mutation-types";
import PasswordSetting from "./components/login/PasswordSetting";
import LoginService from "./api/LoginService";
import { debounce } from "lodash";
// 重写 el-table , 修复固定列横向滚动条问题
import MyTable from './common/components/table';

Vue.component(MyTable.name, MyTable);
Vue.config.productionTip = false

// extend axios to Vue.prototype and Vue static
Vue.use(VueAxios, axios);
extendValidateMessage(zh_CN);
Validator.localize('zh_CN', zh_CN);
Vue.use(VeeValidate, {
    locale: 'zh_CN'
});
extendValidator();

Vue.component('treeselect',Treeselect);



//添加模块递归向上查找权限 add by dhf 2018-06-28
Object.defineProperty(Vue.prototype, "Root_PageAuth", {
    get(){
        let $parent = this;
        while($parent){
            if($parent.hasOwnProperty("root_PageAuth$$")){
                return this.root_PageAuth$$ = $parent.root_PageAuth$$;
            }
            $parent = $parent.$parent;
        }
        return {};
    }
});

// 滚动加载更多
Vue.directive('loadMore', {
    bind(el, binding) {
        // 获取element，定义scroll
        let select_dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        select_dom.addEventListener('scroll', function () {
            let height = this.scrollHeight - this.scrollTop <= this.clientHeight;
            if (height) {
                console.log(binding,8888)
                binding.value()
            }
        })
    }
});

import AccountService from "./api/AccountService";
import {CachePocily} from "./common/Cache";
import {ECache} from "./enum/ECache";
import AuthMixin from "./common/components/AuthMixin";

Vue.mixin(AuthMixin);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    created() {
        // 运营后台虚拟登录
        const autoLogin = this.$route.query.autoLogin;
        const virtualToken = this.$route.query.virtualToken;
        if (autoLogin && virtualToken) {
            const accountService = new AccountService();
            accountService.getAccountInfoByToken({virtual_token: virtualToken}).then((res)=>{
                res = res.data;
                let loginForm = {}
                loginForm.token = res.data.token;
                loginForm.phone = loginForm.account_name = res.data.account_name;
                loginForm.nickname = res.data.nickname;
                loginForm.supplier_id = res.data.supplier_id;
                loginForm.info_complete = res.data.info_complete;
                // this.cache.save(CACHE_KEY.LOGIN,JSON.stringify(loginForm));

                let cache = CachePocily.getInstance(ECache.LocCache);
                cache.save(CACHE_KEY.LOGIN,{
                    ctime: new Date().getTime(),
                    userInfo: JSON.stringify(loginForm)
                });
                this.$store.commit(RootType.UPDATE_TOKEN,virtualToken);
                this.$store.commit(RootType.UPDATE_LOGINMODEL,Object.assign({},loginForm));
                this['getConfig'](loginForm.supplier_id);
                this['getOpenedCode']();
                this['getOpenedEdiStatus']();

                this.$message.success('登录成功');
                if (this.$route.path !== '/home') {
                    this.$router.push('/home');
                } else {
                    this.$router.push('/');
                }
                return ;
            },(error)=>{
                this.$message.error(error.message);
            });
        }

        // 处理token过期时频繁弹出错误提示问题
        this.$message.error = debounce(this.$message.error, 300)
    }
});
